export default "__VITE_ASSET__DxXtjW0___"